app.service('productTabInstalments', function(
	modal,
	console,
	leaseLink,
	productCardConfig,
	cartManager,
	log,
	front,
	callback,
	instalmentSlider
) {
	let $self;
	let state = { code: '', duration: '' };
	function openTab(tabIndex = 0) {
		$self.removeClass().addClass(`show-tab-${tabIndex}`);
	}

	function getInstalmentsTab() {
		const {
			nodeId,
			preview,
			id,
			activeOutletCategory
		} = productCardConfig.getData();

		const data = {
			nodeid: nodeId,
			preview: preview,
			showAll: true,
			productId: id,
			'group-id': 0,
			outletCategoryId: activeOutletCategory
		};

		return $.ajax({
			url: '/product-card-instalment.ltr',
			data: data
		});
	}

	function setActiveInstalmentOption() {
		const $activeOption = $self.find('.instalment-items .is-active');
		const code = $activeOption.data('code');
		const duration = $activeOption.data('duration');
		const warranty = $activeOption.data('warranty');

		setState({ code, duration, warranty });
	}

	function loadTabs() {
		getInstalmentsTab()
			.then(html => {
				console.log('ZAŁADOWANIE ZAKŁADKI: RATY');
				openTab();

				$self.html(html);

				setActiveInstalmentOption();

				$self.find('.instalment-slider').each((i, element) => {
					const $instalmentItem = $(element).closest('.instalment-item');
					const $detailedInstalmentPricing = $instalmentItem.find('.js-detailed-information-price');
					const $detailedPromotionPackagePricing = $instalmentItem.find('.js-promotion-package-detailed-price');
					function setDetailedInstalmentPricing(duration){
						$instalmentItem.data('duration', duration);
						$detailedInstalmentPricing.filter(`[data-option=${duration}]`)
							.addClass('selected-pricing')
							.siblings()
							.removeClass('selected-pricing');
						$detailedPromotionPackagePricing.filter(`[data-option=${duration}]`)
							.addClass('selected-pricing')
							.siblings()
							.removeClass('selected-pricing');
					};
					new instalmentSlider({
						element,
						duration: $(element).data('duration'),
						onInit() {
							//this.runCallback();
							setDetailedInstalmentPricing($(element).data('duration'));
						},
						onChange: data => {
							setDetailedInstalmentPricing(data.duration);
							setState(data);
						}
					});
				});

				leaseLink.init();
			})
			.fail(() => {
				$self.html(
					'<div class="tab-error">Wystąpił błąd ładowania zakładki. Prosimy spróbować później</div>'
				);
			});
	}

	function handleTabClick() {
		const interactionName = `Raty - ${$(this)
			.text()
			.trim()}`;

		UA.pageInteraction('Raty', interactionName);

		const tabIndex = $(this).data('tab-index');
		openTab(tabIndex);
	}

	function setState(newState) {
		state = $.extend({}, newState);
	}

	function handleInstalmentClick() {
		const code = $(this).data('code');
		const duration = $(this).data('duration');
		const warranty = $(this).data('warranty');

		setState({ code, duration, warranty });

		$(this)
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');
	}

	function addInstalment(paymentType, type, warrantyAddedFrom) {
		let config = productCardConfig.getData();
		let plu = config.plu;
		let addedFrom = 'PRODUCT_CARD';

		const { activeOutletCategory } = productCardConfig.getData();

		cartManager.addToCartFromInstalment(
			config.id,
			state.code,
			state.duration,
			paymentType,
			type,
			addedFrom,
			plu,
			activeOutletCategory,
			state.warranty || undefined,
			warrantyAddedFrom
		);

		callback.run('add-to-cart-instalment', {
			productPLU: plu,
			addedFrom
		});
	}

	function handleAddInstalmentClick() {
		const paymentType = $(this).data('payment');
		const warrantyAddedFrom = $(this).closest('.instalment-item').data('warranty') ? 'PRODUCT_CARD_INSTALLMENT_WITH_WARRANTY' : false;

		switch (paymentType) {
			case 'INSTALMENT':
				addInstalment(paymentType, 'SHOP', warrantyAddedFrom);
				UA.pageInteraction('Raty', 'Raty - Raty z doradcą');
				break;

			case 'INSTALMENT_IN_CREDIT_AGRICOLE':
				log.event({
					"id": "Raty przez internet KP",
					"f03": document.location.href,
					"f04": "Kupuje na raty przez internet",
					"f05": "klik",
					"f06": productCardConfig.getData().plu,
					"f07": state.code,
					"f08": state.warranty ? state.warranty : ""
				});
				addInstalment(paymentType, 'HOME', warrantyAddedFrom);
				UA.pageInteraction('Raty', 'Raty - Raty przez Internet');
				break;
		}
	}

	function setEvents() {
		$self
			.on('click', '.js-instalment-popup', handleInstalmentPopupClick)
			.on('click', '.js-preview-warranty-details', handlePreviewWarrantyDetailsClick)
			.on('click', '.js-tab', handleTabClick)
			.on('click', '.js-instalment-item', handleInstalmentClick)
			.on('click', '.js-add-instalment', handleAddInstalmentClick);
	}

	function handleInstalmentPopupClick() {
		modal.open(`instalment-${$(this).data('modal')}`);
	}

	function handlePreviewWarrantyDetailsClick() {
		modal.open(`preview-warranty-${$(this).data('index')}`);
	}

	function init() {
		$self = $('#installments');

		if ($self.length) {
			loadTabs();
			setEvents();
		}
	}

	return {
		init
	};
});
